export const CaregiverForm = ({ children }) => {
  return (
    <div className='container-wrap hsp-form guard-info-form caregiver-info-form btn-fixed'>
      <div className='content-area'>{children}</div>
    </div>
  );
};
